import React from "react";
import { useState, useEffect } from "react";
import i18n from "./i18n";
import { withTranslation, useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import NavigationHelper from "../helpers/navigation";
import LangSwitcher from "./lang_switcher";
import SocialData from "../conf/social.json";
import { Link as GatsbyLink } from "gatsby";
import Link from "./Link";

/** Images import */
import logo from "../images/Logo.png";

export default function Header(props) {
  const { t } = useTranslation(["main", "forms"]);
  const LocalizedLink = withTranslation("main")(GatsbyLink);
  const ExternalLink = withTranslation("main")(Link);

  const voidUrlMap = {
    home: null,
    services: null,
    vision: null,
    testimonials: null,
    client_testimonial: null,
    join: null,
    blog: null,
    legal: null,
    privacy: null,
    terms: null,
  };
  let urlMap = {
    home: NavigationHelper.useGeneratePageURL(i18n.language, "home"),
    services: NavigationHelper.useGeneratePageURL(i18n.language, "services"),
    vision: NavigationHelper.useGeneratePageURL(i18n.language, "vision"),
    testimonials: NavigationHelper.useGeneratePageURL(
      i18n.language,
      "testimonials"
    ),
    client_testimonial: NavigationHelper.useGeneratePageURL(
      i18n.language,
      "client_testimonial"
    ),
    join: NavigationHelper.useGeneratePageURL(i18n.language, "join"),
    blog: NavigationHelper.useGeneratePageURL(i18n.language, "blog"),
    legal: NavigationHelper.useGeneratePageURL(i18n.language, "legal"),
    privacy: NavigationHelper.useGeneratePageURL(i18n.language, "privacy"),
    terms: NavigationHelper.useGeneratePageURL(i18n.language, "terms"),
  };
  const [menuLinks, setMenuLinks] = useState(voidUrlMap);
  useEffect(() => {
    setMenuLinks(urlMap);
  }, [i18n.language]);

  // Header class
  const defaultHeaderClass = "main-header";
  const [headerClass, setHeaderClass] = useState(defaultHeaderClass);
  const pageHeaderClass =
    props.current_page !== "home"
      ? `${defaultHeaderClass} inner-page`
      : defaultHeaderClass;
  useEffect(() => {
    setHeaderClass(pageHeaderClass);
  }, [setHeaderClass]);

  // The class to apply to the menu items
  let itemClasses = { ...voidUrlMap };
  itemClasses[props.current_page] = "active";

  // btn-burger event handler
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className={headerClass}>
      <div className="container">
        <div className="row">
          <div className="col-md-3 col-4 top-logo">
            <div className="logo-container">
              <LocalizedLink
                to={menuLinks.home}
                title={t("main:global_header_home_menu-item-seo-title_txt")}
              >
                <img src={logo} alt="A1 Cloud Technologies: logo" />
              </LocalizedLink>
            </div>
          </div>
          <div className="col-md-9">
            <div className="row">
              <div className="col-md-12">
                <div className="top-bar">
                  <ul>
                    <li className="d-flex apellez-nous">
                      <b>{t("main:global_top-menu_callus_menu-item")}</b>
                      <ExternalLink
                        link={`tel:${t(
                          "main:global_header_phone_number_link"
                        )}`}
                        title={t("main:global_header_phone-link-seo_txt")}
                      >
                        {t("main:global_header_phone_number_txt")}
                      </ExternalLink>
                    </li>
                    <li className="top-icons">
                      <b>{t("main:global_top-menu_followus_menu-item")}</b>
                      <ul>
                        <li>
                          <ExternalLink
                            target="_blank"
                            link={SocialData.urls.linkedin}
                            title={t("main:global_seo_followus_linkedin_txt")}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512"
                            >
                              <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path>
                            </svg>
                          </ExternalLink>
                        </li>
                        {/* <li>
                          <ExternalLink
                            target="_blank"
                            link={SocialData.urls.twitter}
                            title={t("main:global_seo_followus_twitter_txt")}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512"
                            >
                              <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z" />
                            </svg>
                          </ExternalLink>
                        </li> */}
                        {/* <li><a target="_blank" href="#"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM277.3 415.7c-8.4 1.5-11.5-3.7-11.5-8 0-5.4.2-33 .2-55.3 0-15.6-5.2-25.5-11.3-30.7 37-4.1 76-9.2 76-73.1 0-18.2-6.5-27.3-17.1-39 1.7-4.3 7.4-22-1.7-45-13.9-4.3-45.7 17.9-45.7 17.9-13.2-3.7-27.5-5.6-41.6-5.6-14.1 0-28.4 1.9-41.6 5.6 0 0-31.8-22.2-45.7-17.9-9.1 22.9-3.5 40.6-1.7 45-10.6 11.7-15.6 20.8-15.6 39 0 63.6 37.3 69 74.3 73.1-4.8 4.3-9.1 11.7-10.6 22.3-9.5 4.3-33.8 11.7-48.3-13.9-9.1-15.8-25.5-17.1-25.5-17.1-16.2-.2-1.1 10.2-1.1 10.2 10.8 5 18.4 24.2 18.4 24.2 9.7 29.7 56.1 19.7 56.1 19.7 0 13.9.2 36.5.2 40.6 0 4.3-3 9.5-11.5 8-66-22.1-112.2-84.9-112.2-158.3 0-91.8 70.2-161.5 162-161.5S388 165.6 388 257.4c.1 73.4-44.7 136.3-110.7 158.3zm-98.1-61.1c-1.9.4-3.7-.4-3.9-1.7-.2-1.5 1.1-2.8 3-3.2 1.9-.2 3.7.6 3.9 1.9.3 1.3-1 2.6-3 3zm-9.5-.9c0 1.3-1.5 2.4-3.5 2.4-2.2.2-3.7-.9-3.7-2.4 0-1.3 1.5-2.4 3.5-2.4 1.9-.2 3.7.9 3.7 2.4zm-13.7-1.1c-.4 1.3-2.4 1.9-4.1 1.3-1.9-.4-3.2-1.9-2.8-3.2.4-1.3 2.4-1.9 4.1-1.5 2 .6 3.3 2.1 2.8 3.4zm-12.3-5.4c-.9 1.1-2.8.9-4.3-.6-1.5-1.3-1.9-3.2-.9-4.1.9-1.1 2.8-.9 4.3.6 1.3 1.3 1.8 3.3.9 4.1zm-9.1-9.1c-.9.6-2.6 0-3.7-1.5s-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3 1.1 1.5 1.1 3.3 0 4.1zm-6.5-9.7c-.9.9-2.4.4-3.5-.6-1.1-1.3-1.3-2.8-.4-3.5.9-.9 2.4-.4 3.5.6 1.1 1.3 1.3 2.8.4 3.5zm-6.7-7.4c-.4.9-1.7 1.1-2.8.4-1.3-.6-1.9-1.7-1.5-2.6.4-.6 1.5-.9 2.8-.4 1.3.7 1.9 1.8 1.5 2.6z"></path></svg></a></li> */}
                      </ul>
                    </li>
                    <li className="leng">
                      <LangSwitcher
                        current_lang={props.current_lang}
                        current_page={props.current_page}
                        current_item={props.current_item}
                        version_fr_title={t(
                          "main:global_header_lang-switcher-fr-link-seo_txt"
                        )}
                        version_en_title={t(
                          "main:global_header_lang-switcher-en-link-seo_txt"
                        )}
                        version_es_title={t(
                          "main:global_header_lang-switcher-es-link-seo_txt"
                        )}
                      />
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-12 menu-or-btn">
                <div className="logo-container secound-logo">
                  <LocalizedLink to={menuLinks.home}>
                    <img src={logo} alt={t("home_main_our-services_title")} />
                  </LocalizedLink>
                </div>
                <div className="site-nav">
                  <button
                    className={`menu-btn ${menuOpen ? "open" : ""}`}
                    onClick={toggleMenu}
                  >
                    <span className="one"></span>
                    <span className="two"></span>
                    <span className="three"></span>
                  </button>
                  <ul className={`main-menu ${menuOpen ? "open" : ""}`}>
                    <li className="nav-item-link">
                      <LocalizedLink
                        to={menuLinks.home}
                        className={itemClasses["home"]}
                        title={t(
                          "main:global_header_home_menu-item-seo-title_txt"
                        )}
                      >
                        {t("main:global_header_home_menu-item")}
                      </LocalizedLink>
                    </li>
                    <li className="nav-item-link">
                      <LocalizedLink
                        to={menuLinks.services}
                        className={itemClasses["services"]}
                        title={t(
                          "main:global_header_services_menu-item-seo-title_txt"
                        )}
                      >
                        {t("main:global_header_services_menu-item")}
                      </LocalizedLink>
                    </li>
                    <li className="nav-item-link">
                      <LocalizedLink
                        to={menuLinks.testimonials}
                        className={itemClasses["testimonials"]}
                        title={t(
                          "main:global_header_testimonials_menu-item-seo-title_txt"
                        )}
                      >
                        {t("main:global_header_testimonials_menu-item")}
                      </LocalizedLink>
                    </li>
                    <li className="nav-item-link">
                      <LocalizedLink
                        to={menuLinks.vision}
                        className={itemClasses["vision"]}
                        title={t(
                          "main:global_header_vision_menu-item-seo-title_txt"
                        )}
                      >
                        {t("main:global_header_vision_menu-item")}
                      </LocalizedLink>
                    </li>
                    {/* <li className="nav-item-link"><a href={menuLinks.publications}>{t('main:global_header_publications_menu-item' )}</a></li> */}
                    <li className="nav-item-link">
                      <LocalizedLink
                        to={menuLinks.join}
                        className={itemClasses["join"]}
                        title={t(
                          "main:global_header_join_menu-item-seo-title_txt"
                        )}
                      >
                        {t("main:global_header_join_menu-item")}
                      </LocalizedLink>
                    </li>
                    <li className="nav-item-link">
                      <LocalizedLink
                        href={menuLinks.blog}
                        className={itemClasses["blog"]}
                        title={t(
                          "main:global_header_blog_menu-item-seo-title_txt"
                        )}
                      >
                        {t("main:global_header_blog_menu-item")}
                      </LocalizedLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </header>
  );
}
